import { getTmsInstance, hitEventTms } from "@adeo/tms-lib";
export function addTmsTrackingForChooseMyStoreButton(buttonName, buttonType, buttonLocation) {
  hitEventTms(window, 'button.click', {
    'button_name': buttonName,
    'button_type': buttonType,
    'button_location': buttonLocation || 'standalone'
  });
}
export function pushFragment(name, value) {
  getTmsInstance().pushFragment([{
    name,
    value
  }]);
}